import React, { FC } from 'react';
import { Form, Modal } from 'react-bootstrap';
import styles from './EditLandscapeIndicatorDocumentModal.module.css';
import { Button, ValidationForm } from '../../atoms';
import cn from 'classnames';
import { LandscapeDocumentResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-document-response.dto';
import dayjs from 'dayjs';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import TranslationOrganism from '../TranslationOrganism';
import { PromiseSettledResult } from '../../../utils/types/types';

interface EditLandscapeIndicatorDocumentModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  document: LandscapeDocumentResponseDto;
  handleOnChange: (document: LandscapeDocumentResponseDto) => void;
  handleEdit: (document: LandscapeDocumentResponseDto) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const EditLandscapeIndicatorDocumentModal: FC<
  EditLandscapeIndicatorDocumentModalProps
> = ({
  show,
  setShow,
  document,
  handleOnChange,
  handleEdit,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const date = new Date(document.documentDate ?? '');
  const formattedDate = dayjs(date).format('YYYY-MM-DD');
  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <div className={cn(styles.modal)}>
        <ValidationForm
          onSubmitCallback={() => {
            handleEdit(document);
          }}
        >
          <Modal.Body className={cn(styles.modalBody)}>
            <TranslationOrganism
              setLanguage={setLanguage}
              selectedLanguage={selectedLanguage}
              fromLanguage={fromLanguage}
              setFromLanguage={setFromLanguage}
              toLanguage={toLanguage}
              setToLanguage={setToLanguage}
              generateTranslation={generateTranslation}
              generateAllTranslations={generateAllTranslations}
            />
            <Form.Group className="mb-3">
              <Form.Label>Document Name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Enter document name"
                onChange={(e) =>
                  handleOnChange({ ...document, name: e.target.value })
                }
                value={document.name}
              />
              <Form.Control.Feedback type="invalid">
                Please provide valid document name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Document Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document description"
                onChange={(e) =>
                  handleOnChange({ ...document, description: e.target.value })
                }
                value={document.description}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Document Date</Form.Label>
              <Form.Control
                type="date"
                placeholder="Enter document date"
                onChange={(e) =>
                  handleOnChange({ ...document, documentDate: e.target.value })
                }
                value={formattedDate}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Filename</Form.Label>
              <Form.Label className={cn(styles.fileNameWrapper)}>
                {document.file}
              </Form.Label>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer className={cn(styles.modalButtons)}>
            <Button className={cn(styles.button)} variant="dark" type="submit">
              Save
            </Button>
            <Button
              className={cn(styles.cancelButton)}
              variant="light"
              onClick={() => setShow(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </ValidationForm>
      </div>
    </Modal>
  );
};

export default EditLandscapeIndicatorDocumentModal;
